import React, { useState, useEffect } from 'react';

const Watermark = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div 
      className="fixed inset-0 pointer-events-none z-0"
      style={{
        backgroundImage: 'url(/monument-watermark.png)',
        backgroundPosition: isMobile ? 'center center' : 'calc(50% - 8px) center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: isMobile ? '70%' : '32%', // Larger on mobile
        opacity: 0.12,
      }}
    />
  );
};

export default Watermark;
